import request from '@/utils/request'

// 获取所有职业信息
export function GetAllCareer(params) {
  return request({
    url: '/walletUserInfo/getAllCareer',
    method: 'get',
    params
  })
}

// 添加用户添加身份信息及银行卡信息
export function PostAddUserInfo(data) {
  return request({
    url: '/walletUserInfo/add',
    method: 'post',
    data
  })
}

// 获取用户身份信息及银行卡信息
export function PostGetWalletUserInfo(data) {
  return request({
    url: '/walletUserInfo/getWalletUserInfo',
    method: 'post',
    data
  })
}

// JT获取用户身份信息及银行卡信息
export function PostGetWalletUserInfoJt(data) {
  return request({
    url: '/walletUserInfo/getSensitiveWalletUserInfo',
    method: 'post',
    data
  })
}

// 获取用户银行卡信息
export function PostGetWalletUserBankInfo(data) {
  return request({
    url: '/walletUserInfo/getWalletUserBankInfo',
    method: 'post',
    data
  })
}

// 获取所有国家
export function GetAllCountry(params) {
  return request({
    url: '/walletUserInfo/getAllCountry',
    method: 'get',
    params
  })
}

export function GetAllSysBank(params) {
  return request({
    url: '/walletUserInfo/getAllBank',
    method: 'get',
    params
  })
}

// 获取用户余额流水信息
export function getWalletBalancePage(data) {
  return request({
    url: '/walletUserBalance/getBalancePage',
    method: 'post',
    data
  })
}

// 保存工单
export function PostWalletUserIssueSave(data) {
  return request({
    url: '/walletUserIssue/save',
    method: 'post',
    data
  })
}

// 查看工单详情
export function GetWalletUserIssueDetail(params) {
  return request({
    url: '/walletUserIssue/detail',
    method: 'get',
    params
  })
}

// 通过id查看工单详情
export function GetWalletUserIssueDetailById(params) {
  return request({
    url: '/walletUserIssue/detailById',
    method: 'get',
    params
  })
}

// 分页查询工单
export function PostWalletUserIssuePage(data) {
  return request({
    url: '/walletUserIssue/page',
    method: 'post',
    data
  })
}

// 获取工单列表
export function PostWalletUserIssueList(data) {
  return request({
    url: '/walletUserIssue/list',
    method: 'post',
    data
  })
}

// 获取所有银行信息
export function GetAllBank(params) {
  return request({
    url: '/walletUserInfo/getAllBank',
    method: 'get',
    params
  })
}

// 根据国家获取所有的地址列表
export function GetAllAddressByCountryCode(params) {
  return request({
    url: '/address/getAllAddressByCountryCode',
    method: 'get',
    params
  })
}

// 获取省列表
export function GetProvinceAddresses(params) {
  return request({
    url: '/address/getProvinceAddresses',
    method: 'get',
    params
  })
}

// 获取市列表
export function GetCityAddresses(params) {
  return request({
    url: '/address/getCityAddresses',
    method: 'get',
    params
  })
}

// 获取区列表
export function GetDistrictAddresses(params) {
  return request({
    url: '/address/getDistrictAddresses',
    method: 'get',
    params
  })
}

// 获取村列表
export function GetVillageAddresses(params) {
  return request({
    url: '/address/getVillageAddresses',
    method: 'get',
    params
  })
}

// 上传头像
export function PostUploadAvatar(data) {
  return request({
    url: '/walletUserInfo/uploadAvatar',
    method: 'post',
    data
  })
}

// 添加多银行卡
export function AddBankCard(data) {
  return request({
    url: '/walletUserBank/addBankCard',
    method: 'post',
    data
  })
}

// 删除银行卡
export function DeleteBankCard(data) {
  return request({
    url: '/walletUserBank/deleteBankCard',
    method: 'post',
    data
  })
}

// 银行卡详情
export function GetBankCardDetail(data) {
  return request({
    url: '/walletUserBank/getBankCardDetail',
    method: 'post',
    data
  })
}

// 查询用户限额使用进度
export function GetUsedTradeLimit(params) {
  return request({
    url: '/walletUserTransfer/getUsedTradeLimit',
    method: 'get',
    params
  })
}

// 查询用户交易限额配置信息
export function GetTradeLimitConfig(params) {
  return request({
    url: '/walletUserTransfer/getTradeLimitConfig',
    method: 'get',
    params
  })
}
